import * as React from "react";
export function SvgInfo(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width={15} height={15} {...props}>
      <g fill="#666766">
        <path d="M7 6h1v5H7zM7 4h1v1H7z" />
        <path d="M7.5 1C3.9 1 1 3.9 1 7.5S3.9 14 7.5 14 14 11.1 14 7.5 11.1 1 7.5 1zm0 12C4.5 13 2 10.5 2 7.5S4.5 2 7.5 2 13 4.5 13 7.5 10.5 13 7.5 13z" />
      </g>
    </svg>
  );
}
